<template>
  <div>
    <hr sm:hidden class="separator-slim my-10" />
    <div class="wrap-contact-block relative">
      <div class="info-contact">
        <h2 class="mb-2 text-xl">
          Need help choosing your {{ product }} in {{ getLocation() }}?
        </h2>

        <p class="mb-3">Talk to our {{ getLocationName() }} travel experts</p>

        <div class="wrap-social-network">
          <a
            href="//api.whatsapp.com/send/?phone=6281237817770&text=Hi+ZuBlu"
            class="flex items-center font-medium text-primary"
            onclick="sendOkeanosSession('WHATSAPP')"
            target="_blank"
          >
            <svg fill="currentColor" class="mr-1" width="24" height="24">
              <use xlink:href="/img/sprite.svg#ic_whatsapp" />
            </svg>
            <span class="underline cursor-pointer"> Whatsapp us </span>
          </a>
          <trengo-link>
            <template v-slot="{ openChat }">
              <p
                @click="openChat()"
                class="flex items-center font-medium text-primary cursor-pointer"
              >
                <svg width="24" height="24" class="fill-current mr-1">
                  <use xlink:href="/img/sprite.svg#ic_chat"></use>
                </svg>
                <span class="underline"> Chat with us </span>
              </p>
            </template>
          </trengo-link>
        </div>
      </div>
      <div class="w-38 mr-1 wrap-avatar">
        <img src="/img/sophie-avatar.png" alt="sophie avatar" />
      </div>
    </div>
  </div>
</template>

<script>
import { getLocation } from "../../helpers/searchHelpers";
import TrengoLink from "../core/TrengoLink";

export default {
  components: {
    TrengoLink,
  },
  props: ["product"],
  methods: {
    getLocation() {
      return getLocation(window.zubluDestination);
    },
    getLocationName() {
      const data = window.zubluDestination;
      if (data.country) {
        return data.country.name;
      } else if (data.region && data.region.country) {
        return data.region.country.name;
      }
      return window.zubluDestination.name;
    },
  },
};
</script>

<style scoped>
.wrap-contact-block {
  display: flex;
  border: 1px solid var(--primary);
  border-left: 1.5rem solid var(--primary);
  border-radius: 0.5rem;
}

.wrap-social-network {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.wrap-avatar {
  position: absolute;
  bottom: 0;
  right: 0;
}

.info-contact {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.w-38 {
  width: 8rem;
}

@media screen and (max-width: 600px) {
  .info-contact {
    padding: 1rem;
  }

  .wrap-social-network {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
    align-items: start;
    margin-bottom: 2rem;
  }

  .wrap-contact-block {
    margin: 1.25rem 0.75rem;
    background: white;
    border-left: 1px solid var(--primary);
  }
}
</style>
